import type { ReactNode } from "react";
import { useGetIdentity } from "ra-core";
import { Skeleton } from "@/components/ui/skeleton";
import { OnboardingWizard } from "./OnboardingWizard";
import { DeviceNotificationsBanner } from "./DeviceNotificationsBanner";

type IdentityWithOnboarding = {
  onboarding_completed_at?: string | null;
  notifications_enabled?: boolean | null;
};

/**
 * Blocks the CRM until first-login preference onboarding is complete.
 * MFA routes use noLayout, so they are never wrapped by this gate.
 */
export function OnboardingGate({ children }: { children: ReactNode }) {
  const { data: identity, isPending, refetch } = useGetIdentity();

  if (isPending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-8">
        <Skeleton className="h-10 w-48" />
      </div>
    );
  }

  const sale = identity as IdentityWithOnboarding | undefined;
  const needsOnboarding = sale != null && !sale.onboarding_completed_at;

  if (needsOnboarding) {
    return (
      <OnboardingWizard
        onComplete={() => {
          void refetch();
        }}
      />
    );
  }

  return (
    <>
      <DeviceNotificationsBanner />
      {children}
    </>
  );
}
